import { map, split, isEmpty, isNil } from 'lodash';

export default {
  methods: {
    getQuizTags(quiz) {
      if (isEmpty(quiz.tags)) {
        return null;
      }

      return map(split(quiz.tags, ','), item => (`#${item}`));
    },

    isNoOptionsQuiz(options) {
      const OX_QUIZ_OPTIONS_LENGTH = 2;
      return options.length === OX_QUIZ_OPTIONS_LENGTH;
    },

    getQuizState(value) {
      if (isEmpty(value)) {
        return {
          label: '검토중',
          value: 'under_review',
        };
      }

      if (isNil(value.start_at) && !value.is_active) {
        return {
          label: '검토 완료',
          value: 'review_completed',
        };
      }

      if (!isNil(value.start_at) && value.is_active) {
        return {
          label: '출제중',
          value: 'active',
        };
      }

      if (!isNil(value.start_at) && !value.is_active) {
        return {
          label: '종료',
          value: 'end',
        };
      }

      return {
        label: '-',
        value: '',
      };
    },

  },
};



// WEBPACK FOOTER //
// ./src/app/my-quizzes/mixins/quiz.js